(function() {
  const cartDrawer = document.getElementById('cart-drawer');
  console.log('cartDrawer:', cartDrawer);
  if (!cartDrawer) return;

  let debounceTimer;
  new MutationObserver(function() {
    console.log('mutation detected');
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      BSS_B2B.nt.initFunction();
      document.dispatchEvent(new Event("DOMContentLoaded"));
    }, 100);
  }).observe(cartDrawer, { childList: true, subtree: true });
})();
document.addEventListener('DOMContentLoaded', function () {

  function init() {
    const buttons = document.querySelectorAll('#bss-b2b-net-term-button');
    const wrappers = document.querySelectorAll('#bss-b2b-net-term-button-wrapper');

    if (buttons.length < 2) return;

    const drawerBtn = buttons[0];
    const cartBtn   = buttons[1];

    // Sync trạng thái ngay lập tức, không chờ BSS B2B
    cartBtn.style.display  = drawerBtn.style.display;
    if (wrappers[1]) wrappers[1].style.display = wrappers[0].style.display;

    // Theo dõi drawerBtn thay đổi style → sync cartBtn
    const styleObserver = new MutationObserver(function () {
      cartBtn.style.display = drawerBtn.style.display;
      if (wrappers[1]) wrappers[1].style.display = wrappers[0].style.display;
    });
    styleObserver.observe(drawerBtn, { attributes: true, attributeFilter: ['style'] });
  }

  // Init lần đầu
  init();

  // Khi Shopify re-render cart (sau mỗi lần đổi quantity) → init lại ngay
  const cartForm = document.querySelector('.cart-page');
  if (cartForm) {
    let debounceTimer;
    const domObserver = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(init, 50); // 50ms thay vì 1-2s
    });
    domObserver.observe(cartForm, { childList: true, subtree: true });
  }

  // Dùng event delegation cho click, không bị mất dù DOM re-render
  document.addEventListener('click', function (e) {
    if (e.target.closest('#bss-b2b-net-term-button')) {
      const buttons = document.querySelectorAll('#bss-b2b-net-term-button');
      if (buttons.length >= 2 && e.target.closest('#bss-b2b-net-term-button') === buttons[1]) {
        buttons[0].click();
      }
    }
  });

});